var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 61.618,
    height: 69.81,
    viewBox: "0 0 61.618 69.81",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.23,33.9h-33V20.25a9.582,9.582,0,1,1,19.163-.119V22.25a3.179,3.179,0,0,0,3.194,3.179h4.258a3.179,3.179,0,0,0,3.194-3.179V20.131a20.228,20.228,0,1,0-40.455.2V33.9H6.388A6.374,6.374,0,0,0,0,40.262v21.19a6.374,6.374,0,0,0,6.388,6.357H53.23a6.374,6.374,0,0,0,6.388-6.357V40.262A6.374,6.374,0,0,0,53.23,33.9Z",
    transform: "translate(26 814)",
    fill: "none",
    stroke: "#3d5567",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.b23bc093.svg";
export { ForwardRef as ReactComponent };